import { saveUser } from 'communicator/store';
import { fetchSpawnXAuthCode } from 'communicator/utils/api/spawn';

type GenerateXAuthCodeOptions = {
  accessToken: string;
  mark: string;
};

export default async function generateXAuthCodeFromAccessToken({
  accessToken,
  mark
}: GenerateXAuthCodeOptions) {
  const spawnResponse = await fetchSpawnXAuthCode({ accessToken, mark });

  if (spawnResponse.ok) {
    // backend property named access_token but it is actually an x-auth-code
    const xAuthCode = spawnResponse.data.access_token;

    saveUser({ xAuthCode });
  } else {
    // TODO: continue on without xAuthCode?
  }
}
